import { AxiosError } from "axios";
import isEmpty from "lodash-es/isEmpty";
import React from "react";
import { TlxHttpResponse } from "@/api";
import { Message } from "@/components/Message";
import { getDefaultErrorMessage } from "@/helpers/error_message";

const Errors: React.FC<{ errors: AxiosError<TlxHttpResponse>[] }> = ({
  errors,
}) => {
  if (errors.length === 0) return null;
  return (
    <div style={{ display: "grid", gap: "4px" }}>
      {errors.map((error, index) => {
        if (isEmpty(error)) return null;
        const data = (error?.response?.data as { data?: string }).data;
        const message = error?.response?.data?.message;

        let messageToDisplay = data === "Error" || !data ? message : data;
        if (
          messageToDisplay &&
          typeof messageToDisplay === "object" &&
          "name" in messageToDisplay &&
          typeof (messageToDisplay as { name?: unknown }).name === "string"
        ) {
          messageToDisplay = (messageToDisplay as { name: string }).name;
        }
        const resolvedMessage =
          messageToDisplay == null || messageToDisplay === ""
            ? getDefaultErrorMessage(error)
            : String(messageToDisplay);

        return (
          <ErrorMessage message={resolvedMessage} key={`error-gen-${index}`} />
        );
      })}
    </div>
  );
};

export const ErrorMessage: React.FC<{ message?: string }> = ({ message }) => {
  if (!message) return null;
  return <Message text={message} type="warning" />;
};

export default Errors;
